import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";

interface Article {
  LibelleArticle: string;
  QteCommandee: number;
  QteLivree: number;
  QTE_RESTANTE: number;
}

interface CustomTableArticleProps {
  articles: Article[];
}

const CustomTableArticle: React.FC<CustomTableArticleProps> = ({ articles }) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Libellé Article</TableCell>
            <TableCell>Quantité Commandée</TableCell>
            <TableCell>Quantité Livrée</TableCell>
            <TableCell>Reste</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {articles.map((article, index) => (
            <TableRow key={index}>
              <TableCell>{article.LibelleArticle}</TableCell>
              <TableCell>{article.QteCommandee}</TableCell>
              <TableCell>{article.QteLivree}</TableCell>
              <TableCell>{article.QTE_RESTANTE}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CustomTableArticle;
